// src/utils/phoneUtils.ts

// Единый список стран
export const COUNTRIES = [
    { code: 'TJ', flag: '🇹🇯', name: 'Таджикистан', phoneCode: '+992', phoneLength: 9 },
    { code: 'RU', flag: '🇷🇺', name: 'Россия', phoneCode: '+7', phoneLength: 10 },
    { code: 'KZ', flag: '🇰🇿', name: 'Казахстан', phoneCode: '+7', phoneLength: 10 },
    { code: 'UZ', flag: '🇺🇿', name: 'Узбекистан', phoneCode: '+998', phoneLength: 9 },
    { code: 'KG', flag: '🇰🇬', name: 'Кыргызстан', phoneCode: '+996', phoneLength: 9 },
    { code: 'BY', flag: '🇧🇾', name: 'Беларусь', phoneCode: '+375', phoneLength: 9 },
    { code: 'UA', flag: '🇺🇦', name: 'Украина', phoneCode: '+380', phoneLength: 9 },
];

// Список стран для селектов (с флагами и названиями)
export const COUNTRY_CODES = COUNTRIES.map(country => ({
    code: country.code,
    label: `${country.flag} ${country.name}`,
    phoneCode: country.phoneCode
}));

// Список уникальных кодов телефонов
export const getUniquePhoneCodes = () => {
    const uniqueMap = new Map();
    COUNTRIES.forEach(country => {
        if (!uniqueMap.has(country.phoneCode)) {
            uniqueMap.set(country.phoneCode, {
                code: country.phoneCode,
                flag: country.flag,
                name: country.name
            });
        }
    });
    return Array.from(uniqueMap.values());
};

export const PHONE_CODES = getUniquePhoneCodes();

// Связь страны с кодом телефона
export const COUNTRY_PHONE_MAP: Record<string, string> = {};
COUNTRIES.forEach(country => {
    COUNTRY_PHONE_MAP[country.code] = country.phoneCode;
});

// Функция валидации номера телефона
export const validatePhoneNumber = (phone: string, phoneCode: string): boolean => {
    const cleanPhone = phone.replace(/[^0-9]/g, '');
    const country = COUNTRIES.find(c => c.phoneCode === phoneCode);
    if (country) {
        return cleanPhone.length === country.phoneLength;
    }
    return cleanPhone.length >= 8 && cleanPhone.length <= 12;
};

// Получить код страны по коду телефона
export const getCountryCodeByPhoneCode = (phoneCode: string): string => {
    const country = COUNTRIES.find(c => c.phoneCode === phoneCode);
    return country?.code || 'TJ';
};

// Форматирование номера телефона
export const formatPhoneNumber = (value: string, phoneCode: string): string => {
    const cleanValue = value.replace(/[^0-9]/g, '');

    if (phoneCode === '+992') {
        if (cleanValue.length <= 2) return cleanValue;
        if (cleanValue.length <= 5) return `${cleanValue.slice(0, 2)} ${cleanValue.slice(2)}`;
        if (cleanValue.length <= 7) return `${cleanValue.slice(0, 2)} ${cleanValue.slice(2, 5)} ${cleanValue.slice(5)}`;
        return `${cleanValue.slice(0, 2)} ${cleanValue.slice(2, 5)} ${cleanValue.slice(5, 7)} ${cleanValue.slice(7, 9)}`;
    }

    if (phoneCode === '+7') {
        if (cleanValue.length <= 3) return cleanValue;
        if (cleanValue.length <= 6) return `${cleanValue.slice(0, 3)} ${cleanValue.slice(3)}`;
        if (cleanValue.length <= 8) return `${cleanValue.slice(0, 3)} ${cleanValue.slice(3, 6)} ${cleanValue.slice(6)}`;
        return `${cleanValue.slice(0, 3)} ${cleanValue.slice(3, 6)} ${cleanValue.slice(6, 8)} ${cleanValue.slice(8, 10)}`;
    }

    return cleanValue;
};

// Получить пример номера для отображения
export const getPhoneExample = (phoneCode: string): string => {
    const examples: Record<string, string> = {
        '+992': '90 123 45 67',
        '+7': '901 123 45 67',
        '+996': '70 123 45 67',
        '+998': '90 123 45 67',
        '+375': '29 123 45 67',
        '+380': '50 123 45 67',
    };
    return examples[phoneCode] || '123 456 789';
};

// Получить код телефона по коду страны
export const getPhoneCodeByCountryCode = (countryCode: string): string => {
    const country = COUNTRIES.find(c => c.code === countryCode);
    return country?.phoneCode || '+992';
};

// Получить название страны по коду
export const getCountryLabel = (code: string): string => {
    const country = COUNTRIES.find(c => c.code === code);
    return country ? `${country.flag} ${country.name}` : code;
};

// 👇 ДОБАВИТЬ: Нормализация номера (удаляет все кроме цифр)
export const normalizePhone = (phone: string): string => {
    return phone.replace(/[^0-9]/g, '');
};

// 👇 ДОБАВИТЬ: Проверка что номер не пустой и правильной длины
export const isPhoneValid = (phone: string, phoneCode: string): boolean => {
    const cleanPhone = normalizePhone(phone);
    if (!cleanPhone) return false;
    return validatePhoneNumber(phone, phoneCode);
};

// Добавить эту функцию в существующий файл

export const getDisplayPhone = (phoneNumber: string, countryCode: string): string => {
    if (!phoneNumber) return 'Не указан';
    return `${countryCode} ${phoneNumber}`;
};